import { Link } from "react-router-dom";
import MedicalPic from "../images/medical09.jpg";

const DigitalStatementInfo = () => {
  return (
    <div className="max-width">
      <h3>Digital Accessability</h3>
      <p>
        At RozWon Health, we are committed to ensuring that our website is
        accessible to everyone, including individuals with disabilities. We
        strive to follow the Web Content Accessibility Guidelines (WCAG) 2.1
        Level AA to provide an inclusive and user-friendly experience for all
        visitors.
      </p>
      <p>
        Our ongoing efforts include regularly reviewing our site’s design,
        structure and content to identify and address accessibility barriers.
      </p>
      <p>
        We are proud to have achieved strong accessibility scores in independent
        testing tools such as Google Lighthouse and continue to improve
        performance and usability across all devices.
      </p>
      <p>
        If you experience any difficulty accessing information on our site or
        need assistance, please{" "}
        <Link
          to="/contactUs"
          style={{ textDecoration: "none", textTransform: "lowercase" }}
        >
          contact us
        </Link>
        . We welcome your feedback as we work to ensure our website remains
        accessible to everyone.
      </p>
      <div className="accessability">
        <img
          className="accessability-img"
          alt="a doctor and nurse conversating"
          src={MedicalPic}
        />
        <p> Latest update: November 2025</p>
      </div>
    </div>
  );
};

export default DigitalStatementInfo;
